var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{class:_vm.pageStyle.box,attrs:{"default-active":_vm.active}},[_c('Group',{attrs:{"list":_vm.list,"hide":_vm.hide}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }